const csgJapaneseStates = {
  Aichi: 'Aichi',
  Akita: 'Akita',
  Aomori: 'Aomori',
  Chiba: 'Chiba',
  Ehime: 'Ehime',
  Fukui: 'Fukui',
  Fukuoka: 'Fukuoka',
  Fukushima: 'Fukushima',
  Gifu: 'Gifu',
  Gunma: 'Gunma',
  Hiroshima: 'Hiroshima',
  Hokkaido: 'Hokkaido',
  Hyogo: 'Hyogo',
  Ibaraki: 'Ibaraki',
  Ishikawa: 'Ishikawa',
  Iwate: 'Iwate',
  Kagawa: 'Kagawa',
  Kagoshima: 'Kagoshima',
  Kanagawa: 'Kanagawa',
  Kochi: 'Kochi',
  Kumamoto: 'Kumamoto',
  Kyoto: 'Kyoto',
  Mie: 'Mie',
  Miyagi: 'Miyagi',
  Miyazaki: 'Miyazaki',
  Nagano: 'Nagano',
  Nagasaki: 'Nagasaki',
  Nara: 'Nara',
  Niigata: 'Niigata',
  Oita: 'Oita',
  Okayama: 'Okayama',
  Okinawa: 'Okinawa',
  Osaka: 'Osaka',
  Saga: 'Saga',
  Saitama: 'Saitama',
  Shiga: 'Shiga',
  Shimane: 'Shimane',
  Shizuoka: 'Shizuoka',
  Tochigi: 'Tochigi',
  Tokushima: 'Tokushima',
  Tokyo: 'Tokyo',
  Tottori: 'Tottori',
  Toyama: 'Toyama',
  Wakayama: 'Wakayama',
  Yamagata: 'Yamagata',
  Yamaguchi: 'Yamaguchi',
  Yamanashi: 'Yamanashi',
};

const japaneseStateMap = {
  愛知県: csgJapaneseStates.Aichi,
  秋田県: csgJapaneseStates.Akita,
  青森県: csgJapaneseStates.Aomori,
  千葉県: csgJapaneseStates.Chiba,
  愛媛県: csgJapaneseStates.Ehime,
  福井県: csgJapaneseStates.Fukui,
  福岡県: csgJapaneseStates.Fukuoka,
  福島県: csgJapaneseStates.Fukushima,
  岐阜県: csgJapaneseStates.Gifu,
  群馬県: csgJapaneseStates.Gunma,
  広島県: csgJapaneseStates.Hiroshima,
  北海道: csgJapaneseStates.Hokkaido,
  兵庫県: csgJapaneseStates.Hyogo,
  茨城県: csgJapaneseStates.Ibaraki,
  石川県: csgJapaneseStates.Ishikawa,
  岩手県: csgJapaneseStates.Iwate,
  香川県: csgJapaneseStates.Kagawa,
  鹿児島県: csgJapaneseStates.Kagoshima,
  神奈川県: csgJapaneseStates.Kanagawa,
  高知県: csgJapaneseStates.Kochi,
  熊本県: csgJapaneseStates.Kumamoto,
  京都府: csgJapaneseStates.Kyoto,
  三重県: csgJapaneseStates.Mie,
  宮城県: csgJapaneseStates.Miyagi,
  宮崎県: csgJapaneseStates.Miyazaki,
  長野県: csgJapaneseStates.Nagano,
  長崎県: csgJapaneseStates.Nagasaki,
  奈良県: csgJapaneseStates.Nara,
  新潟県: csgJapaneseStates.Niigata,
  大分県: csgJapaneseStates.Oita,
  岡山県: csgJapaneseStates.Okayama,
  沖縄県: csgJapaneseStates.Okinawa,
  大阪府: csgJapaneseStates.Osaka,
  佐賀県: csgJapaneseStates.Saga,
  埼玉県: csgJapaneseStates.Saitama,
  滋賀県: csgJapaneseStates.Shiga,
  島根県: csgJapaneseStates.Shimane,
  静岡県: csgJapaneseStates.Shizuoka,
  栃木県: csgJapaneseStates.Tochigi,
  徳島県: csgJapaneseStates.Tokushima,
  東京都: csgJapaneseStates.Tokyo,
  鳥取県: csgJapaneseStates.Tottori,
  富山県: csgJapaneseStates.Toyama,
  和歌山県: csgJapaneseStates.Wakayama,
  山形県: csgJapaneseStates.Yamagata,
  山口県: csgJapaneseStates.Yamaguchi,
  山梨県: csgJapaneseStates.Yamanashi,
};

export { csgJapaneseStates, japaneseStateMap };
